import { constant } from "lodash";

export const NAME_REQUIRED_ERROR = "Either Organization Name or Contact Name is required.";
export const ADDRESS_REQUIRED_ERROR = "Address 1 is required.";
export const TAXID_REQUIRED_ERROR = "Tax ID is required.";
export const CITY_REQUIRED_ERROR = "City is required.";
export const STATE_REQUIRED_ERROR = "State is required.";
export const ZIP_REQUIRED_ERROR = "Zip is required.";
export const COUNTRY_REQUIRED_ERROR = "Country is required.";
export const TYPE_REQUIRED_ERROR = "Party Type is required.";
export const RELATION_REQUIRED_ERROR = "The required Party Relation field must be completed in order to save the Party.";
export const EMAIL_ERROR = "Invalid email address";
export const WEBSITE_ERROR = "Invalid website url";
export const WORKKARD_CHECKBOX_REQUIRED_ERROR = "Either Add to My Party or Add to Workkard is required.";
export const ACTIVITY_CHECKBOX_REQUIRED_ERROR = "Either Add to My Party or Add to Activity is required.";
export const quickScroll =['#','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
export const PARTIES_WITHOUT_ADDRESS = ["3rd Party", "3rd Party Doctor", "Alternate Contact", "Property Management", "Special Mailer", "Witness"];
export const PARTIES_WITH_TAXID = ["Additional Litigation Party - Company","Additional Daily Party - Company"];
export const SPECIALCHARACTER_NAME_ERROR = "Only letters, numbers, and special characters including ~`@#$%*)(_{}:;\"\/[]',&.- are allowed.";